
import { useState } from 'react';
import '../styles/LoadingAnimation.css';

const ConfirmationDialog = ({
    isOpen,
    title,
    message,
    icon, // e.g., 'warning', 'question', 'error'
    onConfirm,
    onCancel,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
  }) => {
    const [isLoading, setIsLoading] = useState(false);
    
    if (!isOpen) return null;
    
    const handleConfirm = async () => {
      setIsLoading(true);
      try {
        await onConfirm();
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
      <div className="modal-overlay">
        <div className="modal-content" style={{ width: '400px', textAlign: 'center' }}>
          {icon && (
            <div style={{ fontSize: '2em', marginBottom: '10px' }}>
              {icon === 'warning' && '⚠️'}
              {icon === 'question' && '❓'}
              {icon === 'error' && '❌'}
              {}
            </div>
          )}
          <h2 style={{ marginBottom: '20px' }}>{title}</h2>
          <p>{message}</p>
          {isLoading && (
            <div className="loading-spinner" style={{ margin: '20px 0' }}>
              <div className="loading-circle" style={{ borderColor: '#f3f3f3', borderTopColor: '#007bff' }}></div>
              <p style={{ marginTop: '10px', color: '#666', marginBottom: 0 }}>Processing...</p>
            </div>
          )}
          <div className="buttons">
            <button 
              className="button primary"
              onClick={handleConfirm}
              disabled={isLoading}
              style={{ opacity: isLoading ? 0.6 : 1 }}
            >
              {isLoading ? 'Processing...' : confirmLabel}
            </button>
            <button 
              className="button plain"
              onClick={onCancel}
              disabled={isLoading}
              style={{ opacity: isLoading ? 0.6 : 1 }}
            >
              {cancelLabel}
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  export default ConfirmationDialog;